import React from 'react';
import MealMetadataInfo from 'components/meal-content/meal-metadata-page';

const NewMealMetadataInfo = () => {
  return (
    <div>
      <MealMetadataInfo />
    </div>
  );
};

export default NewMealMetadataInfo;
